import { apiClient } from './apiClient';

/** List all users with their role + resolved module permissions (admin only). */
export const getUsers = async () => {
  const response = await apiClient.get('/api/v1/access-control/users');
  return {
    users: response.data?.data || [],
    modules: response.data?.modules || [],
  };
};

/** Replace a non-admin user's granted module set. */
export const updateUserPermissions = async (userId, permissions) => {
  const response = await apiClient.patch(
    `/api/v1/access-control/users/${userId}/permissions`,
    { permissions },
  );
  return response.data?.data;
};

/** Promote/demote a user between 'admin' and 'non-admin'. */
export const updateUserRole = async (userId, roleType) => {
  const response = await apiClient.patch(
    `/api/v1/access-control/users/${userId}/role`,
    { roleType },
  );
  return response.data?.data;
};
